import { useRouter } from 'next/router';

import {
  MessageMenuItem,
  LinkingKakaoAccountMenuItem,
} from '@components/common/dropdown';
import { Alert } from '@components/common/dialog';
import {
  useCreatorSetupButtonLabel,
  useLogout,
  useNavigateCreatorPage,
} from '@hooks/common';
import { useCommonUserProfile, useUserProfile } from '@hooks/user';
import { useModals } from '@hooks/modal';

import type { MenuItem } from '@steadioTypes/dropdown';

type GnbDropdownMenuType = 'PUBLIC' | 'USER';

export default function useGnbDropdownMenuList(
  type: GnbDropdownMenuType = 'PUBLIC',
): MenuItem[] {
  const { userProfile: creatorUserProfile, isSignedOut } = useUserProfile();
  const { userProfile } = useCommonUserProfile();
  const { openModal } = useModals();
  const navigateCreatorPage = useNavigateCreatorPage();
  const logout = useLogout();
  const router = useRouter();
  const isCreator = !isSignedOut && creatorUserProfile?.role === 'CREATOR';
  const useableMessageMenu =
    creatorUserProfile?.joinedCount > 0 || userProfile?.subscribingCount > 0;
  const creatorSetupButtonLabel = useCreatorSetupButtonLabel();

  const onClickManagePayment = () => router.push('/user/payment/management');

  const onClickMembershipSubscriptions = () =>
    router.push('/user/membership/subscriptions');

  const onClickCouponList = () => router.push('/user/coupons/management');

  const onMoveToCreatorPageClick = () =>
    navigateCreatorPage(!isCreator ? 'header' : null);

  const onLogoutClick = async () => {
    try {
      await logout();
      router.replace('/');
    } catch (error) {
      openModal(Alert, {
        content: '로그아웃 에러 발생했습니다.',
      });
    }
  };

  const displayCreatorStudioMenu =
    (isCreator && !router.pathname.includes('creator-studio')) || !isCreator;

  return [
    displayCreatorStudioMenu && {
      onClick: onMoveToCreatorPageClick,
      content: creatorSetupButtonLabel,
      mobileOnly: type === 'PUBLIC',
    },
    {
      onClick: onClickMembershipSubscriptions,
      content: '가입 중인 멤버십',
    },
    useableMessageMenu && { content: <MessageMenuItem /> },
    {
      onClick: onClickCouponList,
      content: '쿠폰함',
    },
    {
      onClick: onClickManagePayment,
      content: '내 결제수단',
    },
    {
      content: <LinkingKakaoAccountMenuItem />,
    },
    {
      onClick: onLogoutClick,
      content: '로그아웃',
    },
  ].filter(Boolean) as MenuItem[];
}
